import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { nameSuccess } from '../slices/authSlice'
const TeamRequests = () => {
  const dispatch = useDispatch()
  dispatch(nameSuccess(false))

  return <></>
}

export default TeamRequests
